import React from 'react';
import { TrendingUpIcon } from 'lucide-react';
import { results } from '../data/content';
export function Results() {
  const [hero, ...rest] = results.stats;
  return <section id="results" className="w-full border-t border-line bg-surface py-24 lg:py-32" data-id="element-148" data-mp="15gcom5fb9r1i">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-149" data-mp="1jbg9ktsn4sbg">
        <div className="grid gap-14 lg:grid-cols-2 lg:items-center lg:gap-20" data-id="element-150" data-mp="1fbeh9b8spb8u">
          <div data-id="element-151" data-mp="1tb724pxn4x8w">
            <p className="display text-sm tracking-widest text-brand-red" data-id="element-152" data-mp="1tanwa7l9lzb8">{results.eyebrow}</p>
            <h2 className="display mt-3 text-[clamp(2rem,4.4vw,3.25rem)] leading-[0.98] text-cream" data-id="element-153" data-mp="1obuew42uxo5s">
              {results.heading}
            </h2>

            {hero && <div className="mt-10 border-l-2 border-brand-green pl-6" data-id="element-154" data-mp="1y25nw51eenjj">
                <p className="display flex items-center gap-3 text-[clamp(3rem,7vw,4.75rem)] leading-none text-brand-green" data-id="element-155" data-mp="2c2gdz5uvvy3n">
                  {hero.value}
                  <TrendingUpIcon className="h-8 w-8" aria-hidden="true" data-id="element-156" data-mp="274oqco19uy59" />
                </p>
                <p className="mt-3 max-w-sm text-base text-cream/70" data-id="element-157" data-mp="1m4cmass0j0o4">{hero.label}</p>
              </div>}

            <dl className="mt-10 grid gap-x-8 gap-y-7 sm:grid-cols-3" data-id="element-158" data-mp="1r2e6jh16d616">
              {rest.map(stat => <div key={stat.label} data-id="element-159" data-mp="1w3blzlusvlyz">
                  <dt className="display text-3xl leading-none text-cream" data-id="element-160" data-mp="210v10nzbo2rz">{stat.value}</dt>
                  <dd className="mt-2 text-sm leading-snug text-cream/60" data-id="element-161" data-mp="2526puradgjz4">{stat.label}</dd>
                </div>)}
            </dl>
          </div>

          <figure className="overflow-hidden rounded-lg border border-line" data-id="element-162" data-mp="29z6vx2781mq8">
            <img src={results.image} alt="Reporting dashboard showing keyword rankings and call volume trending upward" className="h-full w-full object-cover" data-id="element-163" data-mp="2et1eg2b3bvnq" />
          </figure>
        </div>
      </div>
    </section>;
}